var reactResponsive = {exports: {}};

export { reactResponsive as __module };
